module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__service-reports"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.reportsAmount,
      "table-id": "report-services",
      "default-order": "desc",
      "default-sort": "id",
      "showAddButton": false,
      "noBreackColumns": ['traking_number', 'id'],
      "refreshOnCreate": false
    },
    on: {
      "refresh": _vm.getReports
    },
    scopedSlots: _vm._u([{
      key: "created_at",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.item.created_at ? _vm.moment(scope.item.created_at).format('DD.MM.YYYY') : 'Не установленна') + " ")]
      }
    }, {
      key: "weight",
      fn: function(scope) {
        return [(scope.item.weight) ? _c('span', [_vm._v(" " + _vm._s(scope.item.weight) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "size",
      fn: function(scope) {
        return [(scope.item.size) ? _c('span', [_vm._v(" " + _vm._s(scope.item.size) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "from",
      fn: function(scope) {
        return [(scope.item.from) ? _c('div', {
          staticClass: "no-break-hidden"
        }, [_c('span', [_vm._v(" " + _vm._s(scope.item.from.value) + " ")])]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "to",
      fn: function(scope) {
        return [(scope.item.to) ? _c('div', {
          staticClass: "no-break-hidden"
        }, [_c('span', [_vm._v(" " + _vm._s(scope.item.to.value) + " ")])]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "payer",
      fn: function(scope) {
        return [(scope.item.payer) ? _c('div', {
          staticClass: "no-break-hidden"
        }, [_c('span', [_vm._v(" " + _vm._s(scope.item.payer.name) + " ")])]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "payment_method",
      fn: function(scope) {
        return [(scope.item.payment_method) ? _c('span', [_vm._v(" " + _vm._s(scope.item.payment_method.name) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "nds",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s(scope.item.nds) + " ")])]
      }
    }, {
      key: "status",
      fn: function(scope) {
        return [(scope.item.status) ? _c('span', {
          style: ('color: ' + scope.item.status.color + ';')
        }, [_vm._v(" " + _vm._s(scope.item.status.name) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }]),
    model: {
      value: (_vm.reports),
      callback: function($$v) {
        _vm.reports = $$v
      },
      expression: "reports"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.canPrintReport) ? _c('z-button', {
    on: {
      "click": _vm.printReport
    }
  }, [_vm._v(" Распечатать ")]) : _vm._e()], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53154af2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/reports/views/ServicesReport.vue
// module id = 1141
// module chunks = 0